import { ShopperTokenDTO } from '../dto';

export type RefreshTokenStrategy = {
    provideRefreshToken: () => Promise<ShopperTokenDTO | undefined>;
};

export const defaultServerRefreshTokenStrategy: Partial<RefreshTokenStrategy> = {};

export const memoryCacheRefreshTokenStrategy: Partial<RefreshTokenStrategy> = {};
